<!--
  Brand logo for a social network (see MARKETING.PLATFORM).

  Shared because MDI 7 has no X logo, so X falls back to an inline SVG whose path data and theme-aware
  fill nobody should be copy-pasting into a second screen.
-->
<template>
  <span
    class="d-inline-flex align-center"
    role="img"
    :aria-label="name"
    :title="name"
  >
    <v-icon
      v-if="brand.icon"
      :color="brand.color"
      :size="size"
    >
      {{ brand.icon }}
    </v-icon>
    <svg
      v-else
      viewBox="0 0 24 24"
      :width="size - 4"
      :height="size - 4"
      :fill="brand.color"
      aria-hidden="true"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  </span>
</template>

<script>
import { platformName } from '@/helpers/marketing';

export default {
  name: 'PlatformIcon',
  props: {
    // See MARKETING.PLATFORM: 1 Pinterest, 2 Facebook, 3 Instagram, 4 X, 5 LinkedIn.
    platform: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 26
    }
  },
  computed: {
    name() {
      return platformName(this.platform);
    },
    // X returns icon:null so the template falls back to the inline SVG; its mark follows the
    // theme so it stays visible on both backgrounds.
    brand() {
      const map = {
        1: { icon: 'mdi-pinterest', color: '#E60023' }, // Pinterest
        2: { icon: 'mdi-facebook', color: '#1877F2' }, // Facebook
        3: { icon: 'mdi-instagram', color: '#E4405F' }, // Instagram
        4: { icon: null, color: this.$vuetify.theme.dark ? '#FFFFFF' : '#000000' }, // X
        5: { icon: 'mdi-linkedin', color: '#0A66C2' } // LinkedIn
      };
      return map[this.platform] || { icon: 'mdi-web', color: 'grey' };
    }
  }
};
</script>
